import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Text } from '../../components/Text';
import Hint from '../../components/ModuleDrawer/Hint';
import { LoadingBar } from '../../components/util/LoadingBar';
import { DynamicWrapper } from '../../components/util/DynamicWrapper';
import { TextFieldHelperText } from 'rmwc';
import { SelectControl } from '../../components/controls/SelectControl';
import { backOnboarding, continueOnboarding, pathAware } from '../../actions/onboardingActions';

const StyledAnswerRow = styled.div`
  width: 80%;
`;

const accountSpec = {
  field_type: 'single_choice',
  options: [0, 13000, 38000, 63000, 87500, 125500, 175500, 225500, 275500, 350500, 450500, 625500, 875500, 1250125],
  option_data: {
    '0': { label: 'No Savings' },
    '13000': { label: '$1,000-$25,000' },
    '38000': { label: '$26,000-$50,000' },
    '63000': { label: '$51,000-$75,000' },
    '87500': { label: '$75,000-$100,000' },
    '125500': { label: '$101,000-$150,000' },
    '175500': { label: '$151,000-$200,000' },
    '225500': { label: '$201,000-$250,000' },
    '275500': { label: '$251,000-$300,000' },
    '350500': { label: '$301,000-$400,000' },
    '450500': { label: '$401,000-$500,000' },
    '625500': { label: '$501,000-$750,000' },
    '875500': { label: '$751,000-$1,000,000' },
    '1250125': { label: '$1,000,100+' },
  },
};

const savingsAccountTypes = [
  {
    type: 'normal',
    label: 'Normal Retirement Accounts',
    text: 'e.g. Traditional 401(k), and IRA, 403(b), 457(b)',
  },
  {
    type: 'roth',
    label: 'Roth Retirement Accounts',
    text: 'e.g. Roth 401(k) and Roth IRA',
  },
  {
    type: 'education',
    label: 'Education Savings Accounts',
    text: 'e.g. 529 College Savings Plan and Coverdell ESA',
  },
  {
    type: 'regular',
    label: 'Regular Accounts (No Special Tax Treatment)',
    text: 'e.g. Bank Accounts and Personal Brokerage Account',
  },
];

class SavingsAccountAmounts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountTypeAmounts: props.qna_hash.accountTypeAmounts ? props.qna_hash.accountTypeAmounts.answer : {},
    };
  }

  componentDidMount() {
    this.props.pathAware('accountTypeAmounts');
  }

  componentWillReceiveProps(props) {
    if (props.qna_hash.accountTypeAmounts) {
      this.setState({
        accountTypeAmounts: props.qna_hash.accountTypeAmounts.answer,
      });
    }
  }

  _onContinue = () => {
    const { onContinue, qna_hash, qna_stack } = this.props;

    this.props
      .continueOnboarding(qna_stack, qna_hash, {
        accountTypeAmounts: {
          question: 'How much have you already saved so far?',
          answer: this.state.accountTypeAmounts,
        },
      })
      .then(onContinue);
  };

  _canContinue = () => {
    let isFilledOut = true;

    this.props.qna_hash.accountTypes.answer.forEach(item => {
      if (!this.state.accountTypeAmounts[item]) {
        isFilledOut = false;
      }
    });

    return isFilledOut;
  };

  _onBack = () => {
    this.props.backOnboarding(this.props.qna_stack).then(() => this.props.onBack());
  };

  onChange = (evt, field) => {
    const accountTypeAmounts = { ...this.state.accountTypeAmounts };
    accountTypeAmounts[field] = evt.target.value;
    this.setState({ accountTypeAmounts });
  };

  selectAmountRow = option => (
    <StyledAnswerRow key={`${option.type}-amount`}>
      <SelectControl
        id={`${option.type}Amount`}
        label={option.label}
        value={this.state.accountTypeAmounts[option.type]}
        spec={accountSpec}
        onChange={evt => this.onChange(evt, option.type)}
      />
      <TextFieldHelperText className="ml-1 mb-4" persistent>
        {option.text}
      </TextFieldHelperText>
    </StyledAnswerRow>
  );

  render() {
    const { qna_hash, wrapper } = this.props;

    if (!qna_hash.accountTypes) {
      return <LoadingBar />;
    }

    return (
      <DynamicWrapper
        wrapper={wrapper}
        onContinue={this._onContinue}
        onBack={this._onBack}
        canContinue={this._canContinue()}
        helperText={<Hint>Don't worry about getting it perfect! You'll be able to update this information later.</Hint>}
      >
        <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
          <Text use="headline6">How much have you already saved so far?</Text>
        </div>
        <div
          style={{ width: '90%', margin: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
        >
          <Text className="mb-0" use="body1">
            Enter the total amount you {qna_hash.hasPartner.answer ? 'and your spouse ' : ''}have set aside in each
            account type.
          </Text>
        </div>

        {savingsAccountTypes.filter(item => qna_hash.accountTypes.answer.includes(item.type)).map(this.selectAmountRow)}
      </DynamicWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    qna_hash: state.onboarding.qna_hash,
    qna_stack: state.onboarding.qna_stack,
  };
}

export default connect(mapStateToProps, { backOnboarding, continueOnboarding, pathAware })(SavingsAccountAmounts);
